import React, {useEffect, useState} from "react";
import {
  Media,
  Form,
  Input,
  Textarea,
  Fields,
} from "../../components/Form/Form";
import {useNavigate, useParams} from "react-router-dom";
import useStandProductService from "../../api/services/useStandProductService";
import useStandService from "../../api/services/useStandService";
import useForm from "../../hooks/useForm";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import Button from "../../components/Button/Button";


const UserStandProductEdit = () => {

  const {standId, id} = useParams()
  const standProductService = useStandProductService(standId)
  const {userShow: standShow} = useStandService()
  const navigate = useNavigate()
  const form = useForm()
  const [stand, setStand] = useState(null)

  const isNew = !id || id === 'new'

  useEffect(() => {
    standShow((data) => setStand(data), () => {}, standId)
  }, [standId])

  return (
    <div className="page-user-stand-product-edit">
      <div className="row">
        <div className="col">
          <h1>{isNew ? 'Product toevoegen' : 'Product bewerken'}</h1>
          <div className="row buttons">
            <Button label="Alle producten" link={'/user/stand/' + standId + '/aanbod'}/>
            {stand && stand.slug &&
              <Button label="Bekijk profiel" link={'/stand/' + stand.slug}/>
            }
          </div>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup location={'/user/stand/' + standId + '/aanbod/edit'}/>
        </div>
      </div>
      <Form>
        <Fields
          id={isNew ? null : id}
          initData={isNew ? {label: '', description: '', price: '', sort_order: 0} : null}
          form={form}
          apiService={standProductService}
          updateSuccess={() => navigate('/user/stand/' + standId + '/aanbod')}
          showDelete={!isNew}
          deleteLabel="Hiermee verwijder je dit product:"
          deleteSuccess={() => navigate('/user/stand/' + standId + '/aanbod')}
        >
          <Input
            label="Product naam"
            name="label"
            placeholder="Bijv. Kaasstengels"
          />
          <Textarea
            label="Beschrijving"
            name="description"
            placeholder="Optionele beschrijving van het product"
            rows={3}
          />
          <Input
            label="Prijs (€)"
            name="price"
            type="number"
            placeholder="Bijv. 7.50"
          />
          <Input
            label="Volgorde"
            name="sort_order"
            type="number"
            placeholder="0"
          />
          <Media
            label="Foto"
            name="media"
            width={900}
            height={450}
            size="normal"
          />
        </Fields>
      </Form>
    </div>
  )
}

export default UserStandProductEdit
